import { lazy } from "react";

export { NOTIFICATIONS_PATH } from "./notifications-path";
export const Notifications = lazy(
  () => import(/* webpackChunkName: "notifications" */ "./notifications"),
);
